import { FiAward, FiBookOpen, FiBriefcase, FiFlag, FiHeart } from 'react-icons/fi';

// Most recent first.
export const experience = [
  {
    period: '2026 — Present',
    title: 'Engineering Cycle · EHEIM',
    role: "Cycle d'Ingénieur · 3rd year",
    description:
      "Third-year engineering student at EHEIM (École des Hautes Études d'Ingénierie, Oujda), deepening the foundations behind the products I build.",
    icon: FiBookOpen,
    highlight: true,
  },
  {
    period: '2026',
    title: 'WorldSkills Shanghai 2026',
    role: 'Competitor · Web Technologies · Morocco',
    description:
      'Represented Morocco in Web Technologies at the 48th WorldSkills Competition in Shanghai, 22–26 September 2026.',
    icon: FiFlag,

  },
  {
    period: '2025 — 2026',
    title: 'WorldSkills Morocco · Web Technologies',
    role: 'Top 1 national · 1st in the Oriental region',
    description:
      'Competition track judged on performance, accessibility, security and deliverables, built under strict time limits in front of technical juries.',
    icon: FiAward,
  },
  {
    period: '2025 — Present',
    title: 'Freelance Projects',
    role: 'Full-Stack & WordPress Developer',
    description:
      'Building production systems for clients with React, Node.js, Laravel and WordPress, with a focus on performance, security and maintainability.',
    icon: FiBriefcase,
  },
  {
    period: 'Jan — Feb 2025',
    title: 'Internship · CHU Oujda',
    role: 'Full-Stack Developer',
    description:
      'Built an internal training website for hospital staff, and provided user support and continuous integration.',
    icon: FiHeart,
  },
  {
    period: '2023 — 2025',
    title: 'Digital Development (Full Stack)',
    role: 'Développement Digital · PIE innovation program',
    description:
      'Full-stack training and an entrepreneurial innovation program: React, Node.js, Laravel, UX and project delivery.',
    icon: FiBookOpen,
  },
  {
    period: '2022 — 2023',
    title: 'Baccalaureate in Physical Sciences',
    role: 'Scientific foundations',
    description: 'Logic and rigor that still shape how I approach product and engineering problems.',
    icon: FiBookOpen,
  },
];
